<template>
  <!-- 外层容器 -->
  <div class="w-full h-auto py-[3.75vw] bg-[#F5F5F7]">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          校内课程体系
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <transition name="fade" mode="out-in">
      <div
        v-if="currentStage"
        :key="currentTab"
        class="relative flex w-[61.46vw] h-auto mx-auto mb-[2.4vw]"
      >
        <!-- 图片容器 -->
        <div class="flex justify-between w-full h-[15vw]">
          <div
            v-for="(imageItem, imageItemIndex) in currentStage.imageItems"
            :key="imageItemIndex"
            class="relative flex justify-center items-center w-full h-[15vw] rounded-xl group"
          >
            <!-- 图片 -->
            <el-image
              class="w-auto h-full rounded-[0.625vw] object-center object-cover cursor-default"
              :src="
                `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/courseSystem/module2/${imageItem.img}`
              "
              lazy
              alt="课程图片"
            />

            <!-- 文字层（默认隐藏） -->

            <!-- 遮罩层（只有 imageItems.length > 1 才显示） -->
            <div
              v-if="currentStage.imageItems.length > 1"
              class="absolute flex w-full h-[15vw] inset-0 p-[0.8vw] opacity-0 transition-opacity duration-300 group-hover:opacity-100"
            >
              <!-- 渐变背景层 -->
              <div
                class="absolute w-[14.75vw] mx-auto inset-0 bg-gradient-to-t from-[#05358CCC]/90 to-[#05358CCC]/45 rounded-[0.625vw]"
              ></div>
              <!-- 文字内容 -->
              <div
                class="relative flex flex-col justify-center px-[1.875vw] transform translate-y-[5vw] group-hover:translate-y-0 transition-all duration-300 will-change cursor-default"
              >
                <p
                  class="text-[#FFFFFF] text-[1.04vw] font-harmony font-bold mb-[0.4vw]"
                >
                  {{ imageItem.title }}
                </p>
                <p
                  class="text-[#FFFFFF] text-[0.73vw] font-harmony font-normal"
                >
                  {{ imageItem.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 导航区域 -->
    <div
      class="relative w-[61.46vw] h-auto mx-auto mb-[3vw] px-[8.13vw] py-[0.83vw] bg-white rounded-xl"
    >
      <!-- 导航分隔线 -->
      <div
        class="absolute top-1/2 left-0 right-0 transform -translate-y-1/2 flex justify-between"
      >
        <div
          class="w-0 h-[1.25vw] ml-[33%] origin-center outline outline-[0.05vw] outline-[#EAEAEA]"
        ></div>
        <div
          class="w-0 h-[1.25vw] mr-[33%] origin-center outline outline-[0.05vw] outline-[#EAEAEA]"
        ></div>
      </div>

      <!-- 导航文字 -->
      <div class="relative w-full h-auto mx-auto flex flex-row justify-between">
        <!-- 导航项容器 -->
        <div
          v-for="(nav, index) in navItems"
          :key="index"
          @click="currentTab = index"
          class="w-[9.38vw] relative cursor-pointer"
        >
          <!-- 导航内容 -->
          <div class="flex flex-col items-center">
            <div
              :class="
                currentTab === index ? 'text-[#05358c]' : 'text-[#676b73]'
              "
              class="text-[1.04vw] font-harmony font-bold transition-colors duration-300"
            >
              {{ nav.title }}
            </div>
            <div class="font-harmony font-bold text-[#676b73] text-[0.75vw]">
              {{ nav.subtitle }}
            </div>
          </div>
        </div>

        <!-- 底部指示条 -->
        <div
          class="absolute mt-[3.37vw] h-[0.15vw] w-[3.25vw] bg-[#05358c] transition-all duration-[500ms]"
          :style="{
            transform: `translateX(calc(${
              currentTab * 17.95
            }vw + (9.38vw - 3.25vw)/2 ))`,
            left: '0',
          }"
        ></div>
      </div>
    </div>

    <!-- 按钮容器 -->
    <el-button
      native-type="submit"
      class="flex mx-auto justify-center items-center custom-button"
      @mouseenter="hoverButton = true"
      @mouseleave="hoverButton = false"
      @click="smoothScrollToBottom"
    >
      免费试听
    </el-button>
  </div>
</template>

<script>
import {EventBus} from "@/utils/bus";

export default {
  name: "coursesystem-module2",
  data() {
    return {
      currentTab: 0,
      navItems: [
        { title: "小学阶段", subtitle: "认识飞行、参加比赛" },
        { title: "初中阶段", subtitle: "飞行组装、参加比赛" },
        { title: "高中阶段", subtitle: "设计组装、参加比赛" },
      ],
      stages: [
        {
          imageItems: [
            {
              img: "image1.png",
              title: "基础教材",
              description:
                "公司自研创新教材，用于辅助教师教学同时，适用小学生学习理解。",
            },
            {
              img: "image2.png",
              title: "教学资料",
              description:
                "课堂授课演示PPT，课程导入小视频，无人机组装、实验、飞行视频等数字化教学材料让课程更直观，更生动，学生更易于理解。",
            },
            {
              img: "image3.png",
              title: "教学材料包",
              description:
                "公司自主研发的与课程体系配套的航空类教学器材及配套工具包",
            },
            {
              img: "image4.png",
              title: "视频讲解",
              description: "全套视频课程讲解，便于学生理解和学习。",
            },
          ],
        },
        {
          imageItems: [
            {
              img: "image5.png",
              title: "基础教材",
              description:
                "公司自研创新教材，结合初中课程架构，以数学、物理等知识为基础，深入讲解航空器原理及构成挖掘学生动手能力。",
            },
            {
              img: "image6.png",
              title: "教学资料",
              description:
                "课堂授课演示PPT，课程导入小视频，无人机组装、实验、飞行视频等数字化教学材料让课程更直观，更生动，学生更易于理解。",
            },
            {
              img: "image7.png",
              title: "教学材料包",
              description:
                "公司自主研发的与课程体系配套的航空类教学器材及配套工具包",
            },
            {
              img: "image4.png",
              title: "视频讲解",
              description: "全套视频课程讲解，便于学生理解和学习。",
            },
          ],
        },
        {
          imageItems: [{ img: "image8.png" }],
        },
      ],
    };
  },

  methods: {
    // 导航区域切换
    switchTab(index) {
      this.currentTab = index;
    },
    // 平滑滚动到底部
    smoothScrollToBottom() {
      // const targetScroll = document.documentElement.scrollHeight;
      // const startPosition = window.scrollY || window.pageYOffset;
      // const distance = targetScroll - startPosition;
      // let startTime = null;
      //
      // function animation(currentTime) {
      //   if (!startTime) startTime = currentTime;
      //   const timeElapsed = currentTime - startTime;
      //   const run = easeInOutQuad(timeElapsed, startPosition, distance, 1000);
      //   window.scrollTo(0, run);
      //   if (timeElapsed < 1000) requestAnimationFrame(animation);
      // }
      //
      // function easeInOutQuad(t, b, c, d) {
      //   t /= d / 2;
      //   if (t < 1) return (c / 2) * t * t + b;
      //   t--;
      //   return (-c / 2) * (t * (t - 2) - 1) + b;
      // }
      //
      // requestAnimationFrame(animation);
        EventBus.$emit('scroll-to-course','course7');
    },
  },
  // 容器区域切换
  computed: {
    currentStage() {
      return this.stages[this.currentTab];
    },
  },
};
</script>

<style scoped>
/* 自定义按钮样式 */
.custom-button {
  width: 6.87vw;
  height: 2.92vw;
  background: #f28334 !important;
  border: none;
  border-radius: 0.25vw;
  transition: all 0.3s;
}

.custom-button :deep(span) {
  color: white;
  font-size: 1.04vw;
  font-weight: bold;
  font-family: "HarmonyOS Sans SC";
}

.custom-button:hover {
  transform: scale(1.05);
  box-shadow: 0 0.2vw 0.6vw rgba(242, 131, 52, 0.5);
}

/* 过渡动画样式 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
